// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && currentUser.Role !== "admin" && currentUser.Role !== "main-admin") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
